import React from "react";
import LeftPanel from "../utils/LeftPanel";
import AccessDenied from "./AccessDenied";
import { useDevicePermissionsStore } from "../storez/DevicePermissionsStore";
import { useSessionStore } from "../storez/SessionStore";

export default function Authorization(allowedRoles, remoteSupportAdminOnly = false) {
  return (WrappedComponent, FallbackComponent) => {
    return class WithAuthorization extends React.Component {
      constructor(props) {
        super(props);
        this.state = {
          devicePermissions: useDevicePermissionsStore.getState().permissions,
          supportAdmin: useDevicePermissionsStore.getState().supportAdmin,
          available_devices_loaded: useDevicePermissionsStore.getState().loaded,
          remoteSupportAdmin: useSessionStore.getState().remoteSupportAdmin,
        };
      }

      componentWillMount() {
        this.unsubscribe = useDevicePermissionsStore.subscribe(this.onChange);
        this.unsubscribeSession = useSessionStore.subscribe(this.onSessionChange);
      }

      componentWillUnmount() {
        if (this.unsubscribe) {
          this.unsubscribe();
          this.unsubscribe = undefined;
        }

        if (this.unsubscribeSession) {
          this.unsubscribeSession();
          this.unsubscribeSession = undefined;
        }
      }

      onChange = () => {
        this.setState({
          devicePermissions: useDevicePermissionsStore.getState().permissions,
          supportAdmin: useDevicePermissionsStore.getState().supportAdmin,
          available_devices_loaded: useDevicePermissionsStore.getState().loaded,
        });
      };

      onSessionChange = () => {
        this.setState({
          remoteSupportAdmin: !!useSessionStore.getState().remoteSupportAdmin,
        });
      };

      render() {
        if (remoteSupportAdminOnly && this.state.remoteSupportAdmin) {
          return <WrappedComponent {...this.props} />;
        }

        if (!remoteSupportAdminOnly && this.state.supportAdmin) {
          return <WrappedComponent {...this.props} />;
        }

        if (!this.state.available_devices_loaded) {
          return (
            <LeftPanel>
              <div className="padded">
                <div className="row">
                  <div className="col-md-12">Loading....</div>
                </div>
              </div>
            </LeftPanel>
          );
        }

        for (let permission of this.state.devicePermissions) {
          if (allowedRoles.indexOf(permission) !== -1) {
            return <WrappedComponent {...this.props} />;
          }
        }

        if (FallbackComponent) {
          return FallbackComponent();
        }

        return <AccessDenied />;
      }
    };
  };
}
